import BaseUser from "@/project/model/base/BaseUser";

export default class WarehouseModel extends BaseUser {

    id = 0;
    code = '';
    name = '';
    remark = '';

}